import CalendarRouter from 'commons/routers/Calendar.js';
import Employees from 'newCollections/employees.js';
import CompanyLocation from 'newModels/company-location.js';
import Holidays from 'newCollections/holidays';
import LeaveApprovals from 'newCollections/leave-approvals.js';
import ActionLogs from 'newCollections/action-logs.js';
import MainView from '../views/requestLeave/Main';

module.exports = CalendarRouter.extend({
    initialize: function() {
        this.LeaveMainView = MainView;
        CalendarRouter.prototype.initialize.apply(this, arguments);
    },

    _fetchCalendarData: function(locationId) {
        const result = {};
        const layerMap = {};
        const fetchEmployees = function() {
            const approvals = new LeaveApprovals(null, {
                approver: app.employee,
                pagination: false
            });
            return approvals.fetch({filter: {limit: 9999}}).then(() => {
                return Promise.all(
                    approvals.map(approval => {
                        layerMap[approval.get('requesterId')] =
                            approval.get('layer');
                        return approval.fetchRequester();
                    })
                );
            }).then(managed => {
                managed = managed.filter(e => !!e);
                return Promise.all(managed.map(e => {
                    e.fetchLeaveApprovals();
                })).then(() => new Employees(managed));
            }).then(managed => {
                managed.add(app.employee);
                return {
                    employees: managed,
                    userEmployee: app.employee
                };
            });
        };

        return Promise.all([
            new ActionLogs().fetchForEmployee(app.employee),
            fetchEmployees(),
            locationId ?
                new CompanyLocation({objectId: locationId}).fetch() :
                // 20200427 make default to nnull (show employees at ALL
                // locations)
                Promise.resolve(null),
        ])
            .then(([actionLogs, res, location]) => {
                const {employees, userEmployee} = res;
                result.userEmployee = userEmployee;
                result.selectedLocation = location;
                result.employees = employees;

                result.collection = actionLogs;
                result.fetchMore = options => new ActionLogs().fetchForEmployee(
                    app.employee, options
                );
                layerMap[app.employee.id] = 0;

                // keep only unique locations
                const locations = [];
                const locationIds = [];

                return Promise.join(employees.map(employee => {
                    return employee.fetchCompanyLocation()
                        .then(employeeLocation => {
                            if (!locationIds.includes(employeeLocation.id)) {
                                locationIds.push(employeeLocation.id);
                                locations.push(employeeLocation);
                            }
                        });
                })).then(() => {
                    result.locations = locations;
                });
            })
            .then(() => new Holidays(null, {
                company: app.company,
                location: result.selectedLocation.id
            }).fetch())
            .then(holidays => {
                const enabledHolidays = result.selectedLocation ?
                    holidays.filter(h => h._enabled) : holidays;

                result.holidays = enabledHolidays;
                result.isEmployer = false;
                return result;
            });
    },

    _fetchLeaveData: function() {
        return Promise.resolve(new Employees([app.employee], {}));
    }
});



// WEBPACK FOOTER //
// ./app/employee/routers/Calendar.js